(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6496],{

/***/ 48385:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sc/[staticPageSlug]",
      function () {
        return __webpack_require__(34557);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50930);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51992);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37555);
/* harmony import */ var _yema_commerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25144);
/* harmony import */ var functions_fnRequestAPIs_fnProductsAPI__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66221);
/* harmony import */ var functions_fnRequestAPIs_fnProductsPromotion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18009);
/* harmony import */ var _yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46350);
/* harmony import */ var _yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32012);















/** Import CMS Components */ var CMS_BannerSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 3650).then(__webpack_require__.bind(__webpack_require__, 43650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43650)
            ];
        }
    }
});
var CMS_Author = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6529).then(__webpack_require__.bind(__webpack_require__, 96529));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96529)
            ];
        }
    }
});
var CMS_Banner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7221).then(__webpack_require__.bind(__webpack_require__, 77221));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77221)
            ];
        }
    }
});
var CMS_BannerSmall = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9443).then(__webpack_require__.bind(__webpack_require__, 89443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89443)
            ];
        }
    }
});
var CMS_CardForm = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7529), __webpack_require__.e(7607)]).then(__webpack_require__.bind(__webpack_require__, 57270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57270)
            ];
        }
    }
});
var CMS_Reviews = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2947).then(__webpack_require__.bind(__webpack_require__, 72947));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72947)
            ];
        }
    }
});
var CMS_RowCardGroup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9101).then(__webpack_require__.bind(__webpack_require__, 79101));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79101)
            ];
        }
    }
});
var CMS_Body = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9256).then(__webpack_require__.bind(__webpack_require__, 9256));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9256)
            ];
        }
    }
});
var CMS_BodyTitle = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 1937).then(__webpack_require__.bind(__webpack_require__, 71937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71937)
            ];
        }
    }
});
var CMS_ContactUsCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 8009).then(__webpack_require__.bind(__webpack_require__, 4413));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4413)
            ];
        }
    }
});
var CMS_Questions = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2598).then(__webpack_require__.bind(__webpack_require__, 42598));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42598)
            ];
        }
    }
});
var CMSAlgoliaProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(1673), __webpack_require__.e(7261), __webpack_require__.e(4348)]).then(__webpack_require__.bind(__webpack_require__, 95616));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95616)
            ];
        }
    }
});
/**
 * These objects' keys are required to match wagtail component's type
 * DO NOT MODIFY these keys, unless they are modified in Wagtail first
 */ var components = {
    slider: CMS_BannerSlider,
    banner: CMS_Banner,
    reviews: CMS_Reviews,
    cardGroups: CMS_RowCardGroup,
    body: CMS_Body,
    body_content: CMS_Body,
    body_title: CMS_BodyTitle,
    body_title_block: CMS_BodyTitle,
    body_contact_us_card: CMS_ContactUsCard,
    body_questions: CMS_Questions,
    body_card_group: CMS_RowCardGroup,
    body_banner_slider: CMS_BannerSlider,
    body_home_slider: CMS_BannerSlider,
    body_banner: CMS_Banner,
    body_banner_small: CMS_BannerSmall,
    body_form: CMS_CardForm,
    body_written_by: CMS_Author,
    body_algolia_card_group: CMSAlgoliaProducts
};
var CMSPageSkeleton = function() {
    var duration = 1.2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                duration: duration,
                height: 280
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "pb-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "container mb-12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "row",
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6
                        ].map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "col-span-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                        duration: duration,
                                        height: 80
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "mt-1 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                duration: duration,
                                                width: "90%"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "mb-4"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                duration: duration,
                                                width: "50%"
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            })
        ]
    });
};
var CMS_PageBody = function(param) {
    var content = param.content;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_yema_commerce__WEBPACK_IMPORTED_MODULE_5__/* .useStateEngine */ .kG)(), 1), catalog = ref[0].catalog;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(content, [
        "body"
    ])), contentParsed = ref1[0], setContentParsed = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), renderedTime = ref2[0], setRenderedTime = ref2[1];
    var refetchAvailabilitiesAndPromotions = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _shouldRefetchAvailabilities, shouldRefetchAvailabilities, _shouldRefetchPromotions, shouldRefetchPromotions, ref, ref1, fetchedPromotionsPromise, fetchedAvailabilitiesPromise;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _shouldRefetchAvailabilities = param.shouldRefetchAvailabilities, shouldRefetchAvailabilities = _shouldRefetchAvailabilities === void 0 ? false : _shouldRefetchAvailabilities, _shouldRefetchPromotions = param.shouldRefetchPromotions, shouldRefetchPromotions = _shouldRefetchPromotions === void 0 ? false : _shouldRefetchPromotions;
                        ;
                        fetchedPromotionsPromise = shouldRefetchPromotions ? (0,functions_fnRequestAPIs_fnProductsPromotion__WEBPACK_IMPORTED_MODULE_7__/* .fetchProductsPromotions */ .a)({
                            gtinsToFetch: content.productsGtinsInPage,
                            plmIds: content.plmIdsInPage,
                            bundlesIdToFetch: content.bundlesIdsInPage,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref = catalog.store) === null || ref === void 0 ? void 0 : ref.id
                        }) : null;
                        fetchedAvailabilitiesPromise = shouldRefetchAvailabilities ? (0,functions_fnRequestAPIs_fnProductsAPI__WEBPACK_IMPORTED_MODULE_6__/* .getProductsAvailability */ .hj)({
                            gtins: content.gtinsInPage,
                            plmIds: content.plmIdsInPage,
                            zipCode: catalog ? catalog.zipCode : null,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref1 = catalog.store) === null || ref1 === void 0 ? void 0 : ref1.id
                        }) : null;
                        Promise.all([
                            fetchedPromotionsPromise,
                            fetchedAvailabilitiesPromise
                        ]).then(function(res) {
                            var fetchedPromotions = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(res, [
                                0
                            ]);
                            var fetchedAvailabilities = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(res, [
                                1
                            ]);
                            if (fetchedAvailabilities || fetchedPromotions.productsPromotions || fetchedPromotions.bundlesPromotions) {
                                var data = shouldRefetchAvailabilities && shouldRefetchPromotions ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(content, [
                                    "body"
                                ])) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(contentParsed);
                                data.filter(function(item) {
                                    return item.type === "card_group";
                                }).map(function(group) {
                                    var ref, ref1;
                                    (ref1 = (ref = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(group, [
                                        "value",
                                        "cards"
                                    ], [])) === null || ref === void 0 ? void 0 : ref.filter(function(card) {
                                        return card.layout === "product";
                                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(card) {
                                        var gtin = card.title;
                                        // Insert availability information
                                        if (card.product && shouldRefetchAvailabilities && fetchedAvailabilities) {
                                            var ref, ref1;
                                            var availability = fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref = fetchedAvailabilities.availabilities) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                                                return p.gtin === gtin;
                                            });
                                            if (availability) {
                                                card.product.availability = sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .dataTransformers.parseAvailability */ .IZ.parseAvailability(catalog === null || catalog === void 0 ? void 0 : catalog.zipCode, card.product, availability);
                                            } else {
                                                card.product.availability = {
                                                    checkoutMaxQuantity: 0,
                                                    availableOnZipCode: false,
                                                    itemsAvailable: 0,
                                                    status: "unavailable"
                                                };
                                            }
                                            card.product.catalogPrice = fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref1 = fetchedAvailabilities.prices) === null || ref1 === void 0 ? void 0 : ref1.find(function(x) {
                                                return x.sku === gtin;
                                            });
                                        }
                                        // Insert promotion information
                                        if (card.product && shouldRefetchPromotions) {
                                            var promotion = card.isBundle ? fetchedPromotions.bundlesPromotions.find(function(p) {
                                                return p.sku === gtin;
                                            }) : fetchedPromotions.productsPromotions.find(function(p) {
                                                return p.gtin === gtin;
                                            });
                                            if (promotion) {
                                                var firstApplicableRule = sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .rules.getFirstApplicableRule */ .jQ.getFirstApplicableRule((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(promotion, [
                                                    "applicableRules"
                                                ], []), gtin);
                                                card.product.firstApplicableRule = {
                                                    title: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(firstApplicableRule, [
                                                        "title"
                                                    ]),
                                                    icon: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(firstApplicableRule, [
                                                        "campaignIcon"
                                                    ])
                                                };
                                            }
                                        }
                                    });
                                });
                                setContentParsed(data);
                                setRenderedTime(new Date().getTime().toString(36));
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refetchAvailabilitiesAndPromotions(_) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (catalog && catalog.createdAt && catalog.createdAt !== "") {
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on content change (i.e. client-side navigation)
    }, [
        content && content.slug
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (catalog && catalog.createdAt && catalog.createdAt !== "") {
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on catalog settings change
    }, [
        catalog && catalog.createdAt
    ]);
    if (!contentParsed || !contentParsed.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMSPageSkeleton, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: contentParsed && contentParsed.length ? "mb-12" : "",
        children: contentParsed.map(function(element, index) {
            if (!element.type) return "";
            var CustomComponent = components["body_".concat(element.type)];
            if (!CustomComponent) return "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomComponent, {
                blockId: index,
                slug: content.slug,
                typeName: content.__typename,
                content: element.value,
                isBlog: element.type === "banner" || element.type === "body_banner"
            }, "body-elt-".concat(index, "-").concat(renderedTime));
        })
    });
};
var CMS_Page = function(param) {
    var loading = param.loading, content = param.content;
    if (loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMSPageSkeleton, {});
    if (!loading && (!content || !content.body)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_9__["default"], {});
    if (!content || Array.isArray(content.body) && !content.body.length) return "";
    if (typeof content.body === "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "mb-12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMS_Body, {
            content: content.body
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMS_PageBody, {
        content: content
    });
};
CMS_Page.defaultProps = {};
CMS_Page.propTypes = {
    loading: prop_types__WEBPACK_IMPORTED_MODULE_14__.bool,
    content: prop_types__WEBPACK_IMPORTED_MODULE_14__.object
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(CMS_Page));


/***/ }),

/***/ 51586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Page_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2952);
/* harmony import */ var _yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32012);







var NotFoundLayout = function(param) {
    var staticContent = param.staticContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Page_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                staticContent: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, staticContent), {
                    metaTags: {
                        title: "P\xe1gina no encontrada",
                        shouldIndex: false,
                        dismissSeoTags: true
                    }
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__["default"], {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundLayout);


/***/ }),

/***/ 34557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52177);
/* harmony import */ var utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22514);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37555);
/* harmony import */ var layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51586);
/* harmony import */ var layouts_Page_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2952);
/* harmony import */ var components_cms_CMS_Page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72754);









var StaticPage = function(param) {
    var pageContent = param.pageContent, staticContent = param.staticContent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var authToken = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v)(function(param) {
        var authentication = param.authentication;
        return authentication.token;
    });
    var dispatch = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return (0,utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            authToken: authToken,
            dispatch: dispatch
        });
    }, [
        authToken,
        router.asPath
    ]);
    if (!router.isFallback && (!pageContent || !pageContent.data || pageContent.error)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_6__["default"], {
        staticContent: staticContent
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_Page_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        staticContent: staticContent,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_cms_CMS_Page__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            loading: router.isFallback,
            content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_5__/* .get_ */ .jR)(pageContent, [
                "data"
            ])
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (StaticPage);


/***/ }),

/***/ 22514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ initializeUserContext; }
/* harmony export */ });
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37555);
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21166);
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(base_64__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86086);



var rebuildStoreFromCookies = function(dispatch) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var req = ctx ? ctx.req : null;
    var authInfos = sf_modules__WEBPACK_IMPORTED_MODULE_0__/* .cookie.get */ .pR.get("y_usr", req);
    var checkoutInfos = sf_modules__WEBPACK_IMPORTED_MODULE_0__/* .cookie.get */ .pR.get("y_chkt_id", req);
    var actionsToDispatch = [];
    // RE AUTHENTICATE
    if (authInfos) {
        authInfos = JSON.parse(decodeURIComponent(base_64__WEBPACK_IMPORTED_MODULE_1___default().decode(authInfos)));
        actionsToDispatch.push({
            type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .AUTHENTICATE */ .eK,
            payload: authInfos
        });
    } else {
        actionsToDispatch.push({
            type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .SET_GUEST_CUSTOMER */ .Hw
        });
    }
    // REBUILD THE CART
    actionsToDispatch.push({
        type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .CHECKOUT_RESTORE */ .fA,
        payload: {
            checkoutID: checkoutInfos
        }
    });
    dispatch(actionsToDispatch);
};
function initializeUserContext(param) {
    var authToken = param.authToken, dispatch = param.dispatch, _context = param.context, context = _context === void 0 ? null : _context;
    var isServer = "object" === "undefined";
    if (isServer || !authToken) rebuildStoreFromCookies(dispatch, isServer ? context : null);
    dispatch({
        type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .SET_STORE_AS_INITIALIZED */ .dB
    });
};


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9097,6577,1992,2952,4152,9774,2888,179], function() { return __webpack_exec__(48385); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);